import type { JSX } from "react";

import { AppIcon } from "../../common/components/AppIcon.js";
import { useAssignableApps } from "../adminQueries.js";

/**
 * Apps einer Person ein- und ausschalten. Standard: alles an. Der Server setzt die
 * Auswahl in jedem Endpunkt der App durch, nicht nur im App-Raster.
 */
export function MemberApps({ disabled, onChange }: { disabled: string[]; onChange: (disabled: string[]) => void }): JSX.Element | null {
  const apps = useAssignableApps();
  if (!apps.data || apps.data.length === 0) return null;
  const toggle = (id: string, enabled: boolean) => onChange(enabled ? disabled.filter((entry) => entry !== id) : [...disabled, id]);
  return (
    <fieldset className="space-y-2 rounded-xl border border-line bg-surface-sunken p-3">
      <legend className="px-1 text-sm font-bold text-ink">Apps</legend>
      <p className="text-xs text-ink-muted">Abgeschaltete Apps verschwinden für diese Person und sind auch über die Schnittstelle gesperrt.</p>
      <ul className="grid grid-cols-1 gap-1 sm:grid-cols-2">
        {apps.data.map((app) => {
          const enabled = !disabled.includes(app.id);
          return (
            <li key={app.id}>
              <label className="flex min-h-11 cursor-pointer items-center gap-3 rounded-lg px-2 hover:bg-surface-raised">
                <input type="checkbox" checked={enabled} onChange={(event) => toggle(app.id, event.target.checked)} className="h-4 w-4" />
                <AppIcon name={app.icon} className="h-4 w-4 text-ink-muted" />
                <span className="text-sm text-ink">{app.name}</span>
              </label>
            </li>
          );
        })}
      </ul>
    </fieldset>
  );
}
